const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
<div class="o-container o-container--prose o-container--pad">
  <div class="o-container__content o-rhythm">
    <p>
      This content precedes the pullquote. Notice how the pullquote has more margin than usual.
    </p>

    <figure class="wp-block-pullquote
      `);
                if ((context.has(`text_align`) ? context.get(`text_align`) : null)) {
                    this.echo(`has-text-align-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(9, this.source)(...[this.env, (context.has(`text_align`) ? context.get(`text_align`) : null), `html`, null, true]));
                }
                this.echo(`      `);
                if ((context.has(`align`) ? context.get(`align`) : null)) {
                    this.echo(`align`);
                    this.echo(this.env.getFilter('escape').traceableCallable(10, this.source)(...[this.env, (context.has(`align`) ? context.get(`align`) : null), `html`, null, true]));
                }
                this.echo(`">
      <blockquote>
        <p>In case of conflict, consider users over authors over implementors over specifiers over theoretical purity.</p>
        `);
                if ((context.has(`show_citation`) ? context.get(`show_citation`) : null)) {
                    this.echo(`          <cite><a href="https://www.w3.org/TR/html-design-principles/#priority-of-constituencies">HTML Design Principles Priority of Constituencies</a></cite>
        `);
                }
                this.echo(`      </blockquote>
    </figure>

    <p>
      This content follows the pullquote. Notice how the pullquote has more margin than usual.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </p>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `861ec2cdc30f16b06d7c99ea8c5b3faf22ce674d939b06d97f66f3b1005662d2`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `861ec2cdc30f16b06d7c99ea8c5b3faf22ce674d939b06d97f66f3b1005662d2`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '861ec2cdc30f16b06d7c99ea8c5b3faf22ce674d939b06d97f66f3b1005662d2');

let template = env.loadTemplate('861ec2cdc30f16b06d7c99ea8c5b3faf22ce674d939b06d97f66f3b1005662d2');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/pullquote.twig", args: context }
     );
     return rendered;;
};